module.exports = __webpack_public_path__ + "img/tentFire.6d18b80c.svg";